import { useTranslation as useTranslationOriginal } from "gatsby-plugin-react-i18next"

const useCustomTranslation = () => {
  const { t: originalT, i18n } = useTranslationOriginal()

  const t = (key, options = {}) => {
    const translation = originalT(key, { ...options, returnObjects: true })
    if (translation === key) {
      const fallbackTranslation = originalT(`ptc:${key}`)
      return fallbackTranslation !== `ptc:${key}` ? fallbackTranslation : key
    }
    return translation
  }

  return { t, i18n }
}

export default useCustomTranslation
